import axios from "axios";
import { getAppBaseURL } from "./networkUtil";

const API_URLS = "/api/v1/";
const AXIOS_TIMEOUT = { timeout: 15 * 1000 * 60 };

const SERVER_BASE_URL = process.env.REACT_APP_URL + "/advisor/api/v1/" ;

const validateStatusFn = function (status) {
  return status >= 200 && status <= 422; // Treat status codes 200-299 as successful
};

const AxiosInstance = axios.create({
  baseURL: `${SERVER_BASE_URL}`,
  timeout: AXIOS_TIMEOUT,
  validateStatus: validateStatusFn,
});

AxiosInstance.interceptors.request.use((config) => {
  config.baseURL = getAppBaseURL();
  return config;
});
export const AxiosInstanceWithoutTimeout = axios.create({
  baseURL: `${getAppBaseURL()}${API_URLS.apiVersion}`,
});

export default AxiosInstance;
